import { createFileRoute } from '@tanstack/react-router'
import { FileX2 } from 'lucide-react'
import { ErasureCaseScreen } from '@/screens/govern/SCR-045-erasure-case'

function CaseRoute() {
  const { caseId } = Route.useParams()
  return <ErasureCaseScreen key={caseId} caseId={caseId} />
}

export const Route = createFileRoute('/_app/govern/privacy_/$caseId')({
  staticData: { screen: { id: 'SCR-045', title: 'Erasure case', group: 'Govern', perm: 'privacy.manage', hidden: true, description: 'One erasure: impact, progress in every store and receipts.', icon: FileX2 } },
  component: CaseRoute,
})
